import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Canonical domain: redirect www to non-www
if (window.location.hostname === 'www.eunoiaspace.eu') {
  window.location.replace('https://eunoiaspace.eu' + window.location.pathname + window.location.search);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}
